import { useQueryParam, useScrollToTopOnMount } from "hooks"
import { useTranslation } from "react-i18next"
import { HiddenHeader } from "../../components/HiddenHeader"
import type { DeadlineStatus } from "../../graphql"
import { usePageTitle } from "../../tools/usePageTitle"
import { FilterViewConnected } from "../FilterView"
import { FeaturedProducts, FeaturedProductsSkeleton } from "./FeaturedProducts"
import { JourneyTeaser, JourneyTeaserSkeleton } from "./JourneyTeaser"
import { MobileWidgets, MobileWidgetsSkeleton } from "./MobileWidgets"
import {
  ProductCategories,
  ProductCategoriesSkeleton,
} from "./ProductCategories"

import s from "./ForYouView.module.scss"

export const ForYouView = () => {
  useScrollToTopOnMount()
  const { t } = useTranslation()
  usePageTitle(t("pageTitle.FOR_YOU"))

  const [mandatoryQuery] = useQueryParam("mandatory")
  const [deadlineStatus] = useQueryParam<DeadlineStatus>("deadline_status")
  const [incompleteQuery] = useQueryParam("incomplete")
  const isMandatory = mandatoryQuery === "true" ? true : undefined
  const isIncomplete = incompleteQuery === "true" ? true : undefined

  return (
    <div className={s.view}>
      <HiddenHeader title={t("navigation.FOR_YOU")} tag="h1" />
      {isMandatory || isIncomplete ? (
        <FilterViewConnected
          deadlineStatus={deadlineStatus}
          isIncomplete={isIncomplete}
          isMandatory={isMandatory}
        />
      ) : (
        <>
          <FeaturedProducts />
          <JourneyTeaser />
          <MobileWidgets />
          <ProductCategories />
        </>
      )}
    </div>
  )
}

export const ForYouViewSkeleton = () => {
  return (
    <div className={s.loading}>
      <FeaturedProductsSkeleton />
      <JourneyTeaserSkeleton />
      <MobileWidgetsSkeleton />
      <ProductCategoriesSkeleton count={3} />
    </div>
  )
}
